// extracted by mini-css-extract-plugin
export default {"root":"ModeSwitch_root__UQch1","button":"ModeSwitch_button__jJqFg","dark":"ModeSwitch_dark__bho-e","light":"ModeSwitch_light__1f9j-"};